export const isOnHome = url => {
    const urlParts = url.split('/');
    if (!urlParts[3] || urlParts[3] === '') {
        return false;
    }
    return true;
}